import React from 'react';
import Button from '../button/Button';
import { Row, Table } from 'reactstrap';
import { useAppSelector } from '../../reduxToolkit/hooks';
import { jsx } from 'react/jsx-runtime';
import DeleteIcon from '../svg/DeleteIcon';
import EditIcon from '../svg/EditIcon';
import DetailsIcon from '../svg/Details';

function Tables({ data, columns, buttons, isAction = true }: any) {
  const role = useAppSelector((state: any) => state.role.role);
  const totalColumns = role === "Administrator" ? columns.length + 1 : columns.length;
  const columnWidth = `${100 / totalColumns}%`;

  return (
    
    <div style={{ maxHeight: '650px', overflowY: 'auto' }}>
    <Table
      className="text-center"
      size="md"
      hover
      responsive={true}
      style={{ fontSize: '0.95rem', fontFamily: 'Segoe UI, Roboto, sans-serif' }}
    >
      <thead className="bg-light-primary">
        <tr>
          {columns.map((col: any, index: any) => (
             
            <th
              className="table-header"
              style={{
                fontWeight: 600,
                color: '#333',
                padding: '12px',
                fontSize: '1rem',
                width: columnWidth,
                height: '50px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              key={index}
            >
              {col.header}
            </th>
          ))}
          {role === "Administrator" && isAction && (
            <th
              className="table-header"
              style={{
                fontWeight: 600,
                color: '#333',
                padding: '12px',
                fontSize: '1rem',
                width: columnWidth,
                maxWidth: '200px',
                height: '50px',
              }}
            >
              Action
            </th>
          )}
        </tr>
      </thead>

      <tbody className="table-body">
        {data.map((row: any, rowIndex: number) => (
          <tr key={row.id} style={{ height: '60px' }}>
            {columns.map((col: any, colIndex: any) => (
             
              <td
                key={colIndex}
                style={{
                  padding: '10px',
                  maxWidth: col.accessor === 'farmerName' || 'nameOfBeneficiary'  ? '400px' : 'auto',
                  whiteSpace: col.accessor === 'farmerName' || 'nameOfBeneficiary'  ? 'normal' : 'nowrap',
                 
                  textOverflow: col.accessor === 'farmerName' || 'nameOfBeneficiary'  ? 'unset' : 'ellipsis',
                
                }}
              >
                {String(row[col.accessor])}
              </td>
))}

            {role === "Administrator" && isAction && (
              <td>
                <div className="d-flex justify-content-center">
                  {buttons.map((button: any, index: any) => (
                    <Button
                      key={index}
                      color={button.color}
                      onClick={() => button.onClick(row.id)}
                      className={`${button.className} main-button d-flex justify-content-center`}
                    >
                      <div style={{ width: '20px', height: '20px' }}>
                        {button.label === 'Delete' && <DeleteIcon />}
                        {button.label === 'Edit' && <EditIcon />}
                        {button.label === 'Details' && <DetailsIcon />}
                      </div>
                    </Button>
                  ))}
                </div>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
    </div>
  );
}

export default Tables;
